import { ReduxStore } from "../reducers/root_reducer";

const getLatestTos = (state: ReduxStore, props) => state?.tos?.latest;

export default getLatestTos;
